




























































import { Vue, Prop, Component } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Customer from '@/domain/customer/entity/customer.entity';

@Component({
  components: {
    'label-slot': LabelSlot,
  },
})
export default class SearchCustomerComponent extends Vue {
  @Prop() label!: string;

  @Prop() labelOption!: string;

  @Prop() value!: string;

  @Prop() businessUnitId!: string;

  @Prop() customerItemText!: string;

  @Prop() customerOption!: string;

  @Prop({ type: Boolean, default: false })
  searchByDocument!: boolean;

  @Prop({ type: Boolean, default: false })
  showSelectAll!: boolean;

  @Prop({ type: Array, default: () => ([]) })
  customers!: Array<Customer>;

  @Prop({ type: Boolean, default: false }) multiple! : boolean

  selectedAll: boolean = false;

  customerOptions = [
    {
      value: 'name',
      description: 'Razão Social',
    },
    {
      value: 'tradingName',
      description: 'Nome Fantasia',
    },
  ]

  get getCustomerOptions() {
    let opt = [...this.customerOptions];
    if (this.searchByDocument) {
      opt = [
        ...opt,
        {
          value: 'document',
          description: 'CPF/CNPJ',
        },
      ];
    }
    return opt;
  }

  updateField(field: string, value) {
    this.$emit(`update:${field}`, value);
  }

  input(value: string) {
    this.$emit('input', value);
  }

  selectAll() {
    this.$emit('select-all', this.selectedAll);
  }
}
